import { render, staticRenderFns } from "./EdiFiles.vue?vue&type=template&id=525093f2"
import script from "./EdiFiles.vue?vue&type=script&lang=js"
export * from "./EdiFiles.vue?vue&type=script&lang=js"
import style0 from "./EdiFiles.vue?vue&type=style&index=0&id=525093f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports